import "./OurCampus.scss";
import image1 from "../../assets/Home/gallery5.JPG";
import image2 from "../../assets/Home/gallery7.JPG";
import image3 from "../../assets/Home/gallery4.JPG";
import image4 from "../../assets/Home/gallery6.JPG";
import image5 from "../../assets/Home/gallery3.JPG";
import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

const OurCampus = () => {
  const lines = Array.from({ length: 3 });
  const [count, setCount] = useState(0);
  const [start, setStart] = useState(false);
  const ref = useRef(null);
  const navigate = useNavigate();
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setStart(true);
        }
      },
      { threshold: 0.5 } 
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (start) {
      let current = 0;
      const interval = setInterval(() => {
        current++;
        setCount(current);
        if (current >= 150) clearInterval(interval);
      }, 10);
    }
  }, [start]);

  return (
    <div className="green-big-box">
      <div className="green-first-box-section">
        <div className="green-first-section">
          <div className="green-width">
            <div className="left-box">
              <div className="our-campus-title">
                <h2>OUR CAMPUS</h2>
                <div className="our-code" style={styles.container}>
                  {lines.map((_, index) => (
                    <div key={index} style={styles.line}></div>
                  ))}
                </div>
              </div>

              <div className="oc-head">
                Study at <br /> Noorul Islam
              </div>
              <p className="our-campus-para">
                Noorul Islam’s main campus, affectionately referred to as
                Evergreen, is located in a residential neighborhood in North
                Nagercoil. It encompasses 81 wooded acres and is an accredited
                arboretum. Students can often be found studying on the porch of
                the Humanities building, enjoying the lush Quad, participating
                in one of countless clubs, or cheering on our Patriot League
                teams.
              </p>
            </div>

            <div className="right-box">
              {/* <hr className="hr" /> */}
              <div className="number">
                <div ref={ref} className="num">
                  <div>{count}</div>
                </div>
                <div className="head">
                  <div>
                    PROFESSIONAL <br /> TEACHERS
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="img-and-btn">
        <div className="image-section">
          <div className="first-img-width">
            <div className="first-img-div">
              <img
                className="first-img"
                src={image1}
                alt="Our beautiful campus-1"
              />
            </div>
          </div>
          <div className="image-grid">
            <div className="first-img-div">
              <img className="first-img" src={image2} alt="Our campus-2" />
            </div>
            <div className="first-img-div">
              <img className="first-img" src={image3} alt="Our campus-3" />
            </div>
          </div>
          <div className="image-grid">
            <div className="first-img-div">
              <img className="first-img" src={image4} alt="Our campus-4" />
            </div>
            <div className="first-img-div">
              <img className="first-img" src={image5} alt="Our campus-5" />
            </div>
          </div>
        </div>

        <div className="button-container">
          <button
            onClick={() => navigate("/Gallery")}
            className="campus-btn"
          >
            Explore More
          </button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    marginLeft: "10px",
  },
  line: {
    width: "25px",
    height: "1px",
    backgroundColor: "#1CC587",
    transform: "rotate(-150deg)",
    margin: "3px ",
  },
};

export default OurCampus;
